import styled from "styled-components";

const DjzSuccessPageDisplay = styled.div`
  background: ${(p) => p.bgImg};
  background-size: cover;
  min-height: 100vh;
  .formPage {
    padding: 20px;
  }
  .formsLayout .header .logo {
    background: var(--navbarLogo) center center no-repeat;
    height: var(--loginLogoHeight);
    width: var(--loginLogoWidth);
    max-width: 350px;
    background-size: var(--background-size);
  }
  .center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 50vh;
    img {
      max-width: 120px;
      margin-bottom: 16px;
    }
    .message {
      margin-bottom: 20px;
      font-size: 1.1rem;
    }
    .btn {
      padding: 12px 24px;
      background: var(--primary-color, #65378b);
      color: white;
      text-decoration: none;
      border-radius: 4px;
    }
  }
`;

export default DjzSuccessPageDisplay;
